import BigMath from "./math";
import { CurrencyCode, ExchangeRateMap } from "./types";

export class ExchangeRateService {
    constructor( private rateMap: ExchangeRateMap ) {}

    convert(
        amount: number,
        from: CurrencyCode,
        to: CurrencyCode,
    ): number {
        if ( from === to ) return amount;

        const fromRate = from === this.rateMap.base
            ? 1
            : this.rateMap.rates[from];

        const toRate = to === this.rateMap.base
            ? 1
            : this.rateMap.rates[to];

        // 使用 BigMath 进行精确运算并处理除零/缺失情况
        if ( !fromRate || BigMath.isZero( fromRate ) ) {
            console.warn( `Exchange rate for ${from} is missing or zero.` );
            return 0;
        }

        return BigMath.BN( amount )
            .dividedBy( fromRate )
            .times( toRate || 0 )
            .toNumber();
    }
}
